




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Request from "@/modules/request/Request";
import SimpleText from "front-component/components/SimpleText.vue";

@Component({ components: { SimpleText } })
export default class Type extends Vue {
    @Prop( { default: null }) public request!: Request;

    public static getNeededFields(): string[] {
        return [
            "request.type.uuid",
            "request.type.label",
            "request.children.type.uuid",
            "request.children.type.label",
        ];
    }
}
